
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as adminoDxSfL1zfbtXOZhTEjupMIsD_45tLPMDhEkobqeqFztjkMeta } from "/opt/build/repo/pages/admin.vue?macro=true";
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as logindGU_Y4tTcWsCg9HnKfbgxniTJNnqn8Xqf4N3mbSf_459QMeta } from "/opt/build/repo/pages/login.vue?macro=true";
import { default as confirmtfJjcehsAXgzDoakAZcw6ceepd_45_Z6xWt3OaWc4DvHwMeta } from "/opt/build/repo/pages/confirm.vue?macro=true";
import { default as gallerySQR0rhDZvXk7tJEDT6Jh5BmXh3itPRgqHadnU7fy_xUMeta } from "/opt/build/repo/pages/gallery.vue?macro=true";
import { default as uploads9EI3zfGMRmaIBcYw0w7OO0dAIy63jbIxT4egzYqwEKsMeta } from "/opt/build/repo/pages/uploads.vue?macro=true";
export default [
  {
    name: "admin",
    path: "/admin",
    component: () => import("/opt/build/repo/pages/admin.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/opt/build/repo/pages/login.vue")
  },
  {
    name: "confirm",
    path: "/confirm",
    component: () => import("/opt/build/repo/pages/confirm.vue")
  },
  {
    name: "gallery",
    path: "/gallery",
    component: () => import("/opt/build/repo/pages/gallery.vue")
  },
  {
    name: "uploads",
    path: "/uploads",
    component: () => import("/opt/build/repo/pages/uploads.vue")
  }
]